import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { AuthenticationService } from 'src/sb-tools/typescript/authentication/authentication.service';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';
import { CommunityUser } from 'src/sb-tools/typescript/models/community-user.model';
import { CommonDataFaqService } from 'src/app/shared/services/common-data-faq.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class AdminService {
    adminUrl: string;
    adminUrlEditItem: string;
    adminUrlNewTopic: string;
    isAdmin: boolean;
    user: CommunityUser;

    constructor(
        private commonDataFaqService: CommonDataFaqService,
        private authenticationService: AuthenticationService,
        private windowRef: WindowRef,
        @Inject(PLATFORM_ID) private platformId: string,
    ) {}

    logOff(): void {
        this.isAdmin = false;
        this.authenticationService.logOff({
            isStayOnCurrentUrl: true,
            callback: () => {
                if (this.commonDataFaqService.faqSettings.isProtectionEnabled && isPlatformBrowser(this.platformId)) {
                    this.windowRef.nativeWindow.location.reload();
                }
            },
        });
    }
}
